import { useAppSelector } from "../hooks/useAppSelector";
import { getRootAppWindow } from "meta/utils/getRootAppWindow";
export const useContentTabWebEvents = () => {
    const { activeTabKey } = useAppSelector((state) => state.root);
    const patientSelected = (data) => {
        const topFrame = getRootAppWindow(window);
        const activeFrame = topFrame?.frames[activeTabKey];
        activeFrame.RootCommunicator.patientSelected(data);
    };
    const reload = (disableCache) => {
        window.RootAPI.ContentTabs.reload(disableCache);
    };
    return { patientSelected, reload };
};
